const parseEventAccessCode = (id) => {

    const accessCodes = localStorage.getItem("event_access_code");
    const parsedAccessCodes = accessCodes ? JSON.parse(accessCodes) : {};
    const accessCode = parsedAccessCodes[id] || parsedAccessCodes[String(id)] || null;

    return accessCode;
}

export { parseEventAccessCode };